export function sanitizeHtmlTagsAndWhitespace(str: string): string {
  return str.replace(/<(?!\/?b\b)[^>]+>/g, '').replace(/[\n\t\r]/g, '');
}
